var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"MOBILE_h12_Regular",style:({ color: _vm.color })},[_vm._v(_vm._s(_vm.$t('buyTickets.saleEnds')))]),_c('span',{staticClass:"MOBILE_h12_Bold",style:({ color: _vm.color })},[_vm._v(" "+_vm._s(_vm.timerText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }